import { render, staticRenderFns } from "./AddSuccess.vue?vue&type=template&id=5ab8b7d6&scoped=true&"
import script from "./AddSuccess.vue?vue&type=script&lang=js&"
export * from "./AddSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AddSuccess.vue?vue&type=style&index=0&id=5ab8b7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8b7d6",
  null
  
)

export default component.exports